import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['liteTitle', 'businessTitle', 'proTitle', 'liteTable', 'businessTable', 'proTable'];

	toggle(e) {
		this.removeTabStyling();
		this.hideAllTables();

		e.target.setAttribute('data-group-toggled', true);

		this.showTable(e.target);
	}

	removeTabStyling() {
		//remove styling from tabs
		this.liteTitleTarget.removeAttribute('data-group-toggled');
		this.businessTitleTarget.removeAttribute('data-group-toggled');
		this.proTitleTarget.removeAttribute('data-group-toggled');
	}

	hideAllTables() {
		//add hidden to all tables
		this.liteTableTarget.classList.add('hidden');
		this.businessTableTarget.classList.add('hidden');
		this.proTableTarget.classList.add('hidden');
	}

	showTable(target) {
		if (target == this.liteTitleTarget) {
			this.liteTableTarget.classList.remove('hidden');
		}
		if (target == this.businessTitleTarget) {
			this.businessTableTarget.classList.remove('hidden');
		}
		if (target == this.proTitleTarget) {
			this.proTableTarget.classList.remove('hidden');
		}
	}
}
